import React from 'react';

export const path =
  'M8.304,7.994 L5.7,7.994 C5.252,7.994 5,7.756 5,7.294 L5,0.7 C5,0.238 5.252,0 5.7,0 L8.304,0 C8.752,0 9.004,0.238 9.004,0.7 L9.004,7.294 C9.004,7.756 8.752,7.994 8.304,7.994 Z M8.304,14 L5.7,14 C5.252,14 5,13.748 5,13.3 L5,10.696 C5,10.248 5.238,9.996 5.7,9.996 L8.304,9.996 C8.752,9.996 9.004,10.248 9.004,10.696 L9.004,13.3 C9.004,13.748 8.752,14 8.304,14 Z';

export default class Ajax extends React.PureComponent {
  render() {
    return (
      <g>
        <rect width="14" height="14" opacity="0" />
        <path d={path} className="fill-current" />
      </g>
    );
  }
}
